// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-chip[data-v-4be834f0]{height:18px!important;padding:0 8px!important;border-radius:14px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
